import ReactToPrint from 'react-to-print';
import React, { useRef } from 'react';
import { Helmet } from 'react-helmet-async';

import ComponentToPrint from './ComponentToPrint';

const Cv = () => {
  const componentRef = useRef();
  return (
    <>
      <Helmet>
        <title>Resume | Slávka Vavřinová</title>
        <meta
          name="description"
          content="Životopis Ing. Stanislavy Vavřinové – full-stack developer u Robert Bosch, Czechitas lektorka, UX designérka."
        />
        <link rel="canonical" href="https://www.slavkavav.cz/resume" />
      </Helmet>
      <h2>Resume</h2>
      <ComponentToPrint ref={componentRef} />
      <div className="center">
        <ReactToPrint
          trigger={() => <button className="button ">PRINT RESUME</button>}
          content={() => componentRef.current}
        />
      </div>
      <div className="center figma">
        <a
          href="https://www.figma.com/file/cVkJFgbxO9VTppxduzrz7H/CV?node-id=0%3A1"
          target="_blank"
          rel="noreferrer"
        >
          <button className="button button--targetBlank">Figma</button>
        </a>
      </div>
    </>
  );
};

export default Cv;
